type ResponsiveSize = {
  base?: string
  sm?: string
  md?: string
  lg?: string
  xl?: string
}

/** Dashboard mini stat row — compact on mobile (smaller type), 155px from lg up. */
export const dashboardMiniStatCardHeight: ResponsiveSize = {
  base: "108px",
  sm: "128px",
  md: "140px",
  lg: "155px",
  xl: "155px",
}

export const dashboardMiniStatCardHeightCompact: ResponsiveSize = {
  base: "96px",
  sm: "108px",
  md: "110px",
  lg: "120px",
  xl: "120px",
}

export const dashboardMiniStatCardHeightClassName =
  "h-[108px] sm:h-[128px] md:h-[140px] lg:h-[155px] xl:h-[155px]"

export const dashboardMiniStatCardHeightCompactClassName =
  "h-[96px] sm:h-[108px] md:h-[110px] lg:h-[120px] xl:h-[120px]"

function responsiveSizeMatches(a: ResponsiveSize, b: ResponsiveSize): boolean {
  return (
    a.base === b.base &&
    a.sm === b.sm &&
    a.md === b.md &&
    a.lg === b.lg &&
    a.xl === b.xl
  )
}

export function liftedTitleCardUniformHeight(height?: ResponsiveSize): string | undefined {
  if (!height?.base || height.base === "auto") return undefined
  const steps = [height.base, height.sm, height.md, height.lg, height.xl].filter(Boolean)
  return steps.length > 0 && steps.every((value) => value === height.base)
    ? height.base
    : undefined
}

export function liftedTitleCardHeightClass(height?: ResponsiveSize): string {
  if (!height) {
    return "h-[140px] sm:h-[160px] md:h-[185px] lg:h-[185px]"
  }
  if (height.base === "auto" || height.md === "auto") {
    return "h-auto"
  }
  if (responsiveSizeMatches(height, dashboardMiniStatCardHeight)) {
    return dashboardMiniStatCardHeightClassName
  }
  if (responsiveSizeMatches(height, dashboardMiniStatCardHeightCompact)) {
    return dashboardMiniStatCardHeightCompactClassName
  }
  if (liftedTitleCardUniformHeight(height)) {
    return ""
  }
  const classes: string[] = []
  if (height.base) classes.push(`h-[${height.base}]`)
  if (height.sm) classes.push(`sm:h-[${height.sm}]`)
  if (height.md) classes.push(`md:h-[${height.md}]`)
  if (height.lg) classes.push(`lg:h-[${height.lg}]`)
  if (height.xl) classes.push(`xl:h-[${height.xl}]`)
  return classes.join(" ")
}

export function liftedTitleCardPaddingClass(
  axis: "pl" | "pr" | "py",
  padding?: ResponsiveSize,
  fallback?: string
): string {
  if (!padding) return fallback ?? ""
  const classes: string[] = []
  if (padding.base) classes.push(`${axis}-[${padding.base}]`)
  if (padding.sm) classes.push(`sm:${axis}-[${padding.sm}]`)
  if (padding.md) classes.push(`md:${axis}-[${padding.md}]`)
  if (padding.lg) classes.push(`lg:${axis}-[${padding.lg}]`)
  if (padding.xl) classes.push(`xl:${axis}-[${padding.xl}]`)
  return classes.length > 0 ? classes.join(" ") : (fallback ?? "")
}
